'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var IS_NOT_FOUND_UPDATED = 'is-not-found:updated';

exports.IS_NOT_FOUND_UPDATED = IS_NOT_FOUND_UPDATED;
